 if (!customElements.get('variant-selects')) { 
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);

      const radioInputs = this.querySelectorAll('input[type="radio"]');
      const groupNames = new Set();
      radioInputs.forEach(radio => {
        groupNames.add(radio.name);
      });

      this.selectionsCount = groupNames.size;
      this.allSelected = true;
    }

    onVariantChange(e) {
      this.updateOptions();
      this.updateVariantId();
      this.updateBuffByYou(e);
      this.toggleAddButton(true);
      this.updateDeliveryMethods();
      this.removeErrorMessage();
      //update BIS button?

      if (!this.currentVariant) {
        this.toggleAddButton(true);
        this.setUnavailable();
      } else {
      //  this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        // this.updateShareUrl();
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (input) => input.value);
      if (this.options.size == this.selectionsCount) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    }

    updateVariantId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateBuffByYou(e) {
      const bby = this.closest('section')?.querySelector("buff-by-you");
      if (!bby) return;

      const mediaGallery = this.closest('section')?.querySelector(`#Product-MediaGallery-${this.dataset.section}`);
      mediaGallery?.resetSlider()

      bby.updateFilagree(e);
      bby.updateProgressBar(e);
      bby.disableDoubleScents(this);

      if (this.currentVariant?.buff_name) {
        //update text input name
        bby.updateTextInput(this.currentVariant.buff_name);

        //update image label name
        bby.updateGeneratedLabel(this.currentVariant.buff_name);
      }
    }


    /*  Didn't implement because we don't currently have products where we assign images to variants
        This code is from the accelerator and would probably need to be modified to because mediaGallery html changed
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGallery = document.getElementById(`Product-MediaGallery-${this.dataset.section}`);
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }
    */

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return; //this dataset.updateUrl doesn't appear in the html. Wonder if accelerator forgot about it or was planning on adding that as a customizer option
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    /*  Didn't implement because we don't currently see the point of sharing variant specific instances of products with current structure
        Accelerator code that appears unfinished. shareButton.updateUrl isn't a function
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    */

    updateVariantInput() {
      const productForms =
        document.querySelectorAll(`#Product-Form-${this.dataset.section}, #Product-Form-${this.dataset.section}-Sticky, #Installment-${this.dataset.section}`);

      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`Price-${this.dataset.section}`);
          const source = html.getElementById(`Price-${this.dataset.section}`);
          if (source && destination) destination.innerHTML = source.innerHTML;

          const price = document.getElementById(`Price-${this.dataset.section}`);

          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }

    toggleAddButton(disable = true, text) {
      const productForms = document.querySelectorAll(`#Product-Form-${this.dataset.section}, #Product-Form-${this.dataset.section}-Sticky`);
      if (!productForms.length) return;

      productForms.forEach((productForm) => {
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      });
    }

    setUnavailable() {
      const productForms = document.querySelectorAll(`#Product-Form-${this.dataset.section}, #Product-Form-${this.dataset.section}-Sticky`);
      const price = document.getElementById(`Price-${this.dataset.section}`);

      productForms.forEach((button) => {
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');

        if (!addButton) return;

        addButtonText.textContent = this.allSelected ? window.variantStrings.unavailable : window.variantStrings.selectOptions;
      });
      if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateDeliveryMethods() {
      const deliveryMethods = document.querySelector('delivery-methods');
      if (!deliveryMethods || !this.currentVariant) return;
      
      deliveryMethods.render(this.currentVariant.id);
    }
  }

  customElements.define('variant-selects', VariantSelects);
}
